import { useEffect } from 'react';

/**
 * Mantiene allineata la classe sul container dashboard con lo stato reale del fullscreen
 * (es. uscita con Esc), oltre al toggle via bottone.
 */
export function useSyncDashboardFullscreenClass(
    containerSelector = '.mtska-dashboard-container',
    fullscreenClassName = 'mtska-fullscreen'
) {
    useEffect(() => {
        const sync = () => {
            const parent = document.querySelector(containerSelector);
            if (!parent) return;
            const fsEl = document.fullscreenElement ?? document.webkitFullscreenElement;
            if (fsEl === parent) parent.classList.add(fullscreenClassName);
            else parent.classList.remove(fullscreenClassName);
        };

        document.addEventListener('fullscreenchange', sync);
        document.addEventListener('webkitfullscreenchange', sync);
        sync();

        return () => {
            document.removeEventListener('fullscreenchange', sync);
            document.removeEventListener('webkitfullscreenchange', sync);
        };
    }, [containerSelector, fullscreenClassName]);
}
